module.exports = __webpack_public_path__ + "static/media/W18-0869_AW_Cod_Burger_LTO_mobile_hero_767x845_fr.8bd7fe9d.jpg";